import { useQuery } from "@tanstack/react-query";
import { riskReviewKeys } from "../constants/riskReviewQueryKeys";
import riskReviewService from "../services/riskReviewService";

export const useRiskReviewApprovals = (filters) =>
  useQuery({
    queryKey: riskReviewKeys.approvals(filters),
    queryFn: () => riskReviewService.getMyApprovals(filters),
    staleTime: 15000,
  });
